import React, { createRef } from 'react';
import { IonInput, IonChip, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import { image, checkmark, create, closeCircle, caretDownOutline, checkmarkCircle, headset, star, pricetag, close, volumeHigh, trash, more, add, albums, wallet, bulb, gitMerge, school, barbell, cloudDownload, cloudUpload, notificationsCircle, trendingUp, checkmarkDoneOutline, checkmarkOutline, addOutline, arrowUpCircleOutline, downloadOutline, logInOutline, eye, logIn, archive, checkmarkDoneCircle, playCircle, arrowRedoCircle, reloadCircle, caretUpCircle, checkmarkDone, linkOutline, closeOutline, stopCircle } from 'ionicons/icons'
import Utilities from '../Utilities';
import ReactTooltip from 'react-tooltip';
import ImagePreviewModal from './ImagePreviewModal';
import SQLStorage from '../SQLStorage';

import { Browser } from '@capacitor/browser';

class Flashcard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            openImageI: null
        };
    }

    async pronounceWord(term, definition) {

        if (!this.props.termPronouncation && !this.props.definitionPronouncation) {
            window.toast(window.ln.unsupportedLangP, "error");
            return;
        }

        this.setState({ pronouncing: true })

        if (this.props.termPronouncation && term)
            await Utilities.pronounceWord(term, this.props.term);

        if (this.props.definitionPronouncation && definition)
            await Utilities.pronounceWord(definition, this.props.definition);

        this.setState({ pronouncing: false })

    }

    openImage(e, url) {
        e.stopPropagation();
        e.preventDefault();
        Utilities.trackEvent("Flashcard", "Flashcard Open Image");
        Browser.open({ url: url });
    }

    render() {

        const fontSize = !this.props.fontSize || this.props.fontSize === "3" ? "9vmin" : this.props.fontSize === "2" ? "7vmin" : this.props.fontSize === "1" ? "5vmin": this.props.fontSize === "4" ? "14vmin" : "20vmin"
        const item = this.props.flashcard;
        const contentDOM =                 
        <React.Fragment>
            { (this.props.setName) &&
                <IonChip> <IonLabel>{window.ln.foundIn.replace("__", this.props.setName)}</IonLabel> </IonChip>
            }
            { (this.props.altChip) &&
                <IonChip> <IonLabel>{this.props.altChip}</IonLabel> </IonChip>
            }
            { (this.props.altBtn) &&
                <IonChip
                    style={{
                        background: "#fa4252",
                        float: "right",
                        marginRight: 0
                    }}
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                        this.props.altBtnClick();
                    }}
                > <IonLabel>{this.props.altBtn}</IonLabel> </IonChip>
            }
            <div 
                className="options clearfix" 
                data-editing={item.editing} 
                onClick={(e) => {
                    if (this.props.view === "flashcard") {
                        e.stopPropagation();
                        e.preventDefault();
                        this.props.onClick();
                    }
                }}
                style={ (this.props.view === "flashcard") ? { textAlign: "right" } : {} }
            >
                <span className="strength">
                    <div data-color={item.strength || "10"} className="circle">
                        <IonIcon style={{ fontSize: 20 }} className="strength-icon" icon={item.strength === 1 ? playCircle : (item.strength === 3) ? checkmarkCircle : (item.strength === 5) ? checkmarkDoneCircle : caretUpCircle} />
                    </div>
                    <label>{item.strength === 1 ? window.ln.studying : (item.strength === 3) ? window.ln.learnt : (item.strength === 5) ? window.ln.mastered : window.ln.new}</label>
                </span>
                <span className="review-cycle">
                    <div data-color="0" className="circle">
                        <IonIcon className="review-icon" icon={reloadCircle} />
                    </div>
                    <label>{ (item.revisionCycle && item.revisionCycle < 100 && item.revisionCycle > 0) ? item.revisionCycle : "-"}</label>
                </span> 
                <span className="review-count">
                    <div data-color="0" className="circle">
                        <IonIcon className="review-icon" icon={eye} />
                    </div>
                    <label>{item.reviewCount || "0"}</label>
                </span> 
                { (this.props.view === "flashcard" && item.star) &&
                    <span className="review-count">
                        <div data-color="0" className="circle">
                            <IonIcon className="starred star-icon" icon={star} />
                        </div>
                    </span> 
                }
                { (this.props.view === "flashcard") &&
                    <span className="review-count">
                        <div data-color="0" className="circle">
                            <IonIcon icon={create} />
                        </div>
                    </span> 
                }
                { (this.props.view !== "flashcard" && this.props.view !== "minimal") &&
                    <div className='right'>
                        { ((this.props.termPronouncation && item.term) || (this.props.definitionPronouncation && item.definition)) &&
                            <IonIcon
                                className="pronounce-icon"
                                icon={volumeHigh}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.pronounceWord(item.term, item.definition); }}
                            />
                        }
                        <IonIcon className={(item.star ? "starred" : "") + " star-icon"} icon={star} />
                        <IonIcon icon={create} />
                    </div>
                }
                { ( (this.props.side === "front" || this.props.side === "back") && this.props.totalI ) &&
                    <div className='left'>
                        <div className='nth'>
                            <span>{this.props.i+1}</span>
                            <span>/</span>
                            <span>{this.props.totalI}</span>
                        </div>
                    </div>
                }
            </div>
            { (!this.props.side || this.props.side === "front") && <p style={(this.props.view === "flashcard" ? { alignSelf: 'center', fontSize: fontSize } : { })}>{item.term || "✘ " + window.ln.noTerm}</p> }
            { (!this.props.side || this.props.side === "back") && <p style={(this.props.view === "flashcard" ? { alignSelf: 'center', fontSize: fontSize } : { })}>{(item.definition || "✘ " + window.ln.noDef)}</p> }
            { (!this.props.side || this.props.side === "back") && item.customText2 && item.customText2.length !== 0 && 
                <React.Fragment>
                    { item.customText2.map(customField => {
                        return (
                            <p style={(this.props.view === "flashcard" ? { alignSelf: 'center', marginTop: 6,fontStyle: 'italic' } : { marginTop: 6,fontStyle: 'italic' })}>{customField}</p>
                        );
                    }) }
                </React.Fragment>
            }
            { ( (!this.props.side || this.props.side === "back") && (item.customText1 && item.customText1.length !== 0) ) &&
                <div 
                    className="images"
                    style={this.props.view === "flashcard" ? { textAlign: 'center' } : {}}
                >
                    { item.customText1.map((image, i) => {
                        let callbackElementRand = image.startsWith("data:") ? null : (image + "-" + i);

                        if (window.os !== "web" && callbackElementRand) {
                            Utilities.getImage(item.id, image, true, callbackElementRand);
                        }

                        return (
                            <div onClick={(e) => {
                                if (this.props.view === "flashcard") {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    this.setState({
                                        openImageI: i
                                    })
                                }
                            }}>
                                { (window.os === "web" || !callbackElementRand) ?
                                    <div className='image'>
                                        <img src={image} />
                                    </div>
                                    :
                                    <div className='image image-loading' data-rand={callbackElementRand} />
                                }
                            </div>
                        )
                    }) }
                </div>
            }
            { (this.props.view === "flashcard") && 
                <div className='dummy-buttons'>
                    
                </div>
            }
            { ( (this.props.view !== "flashcard") && ( ( (item.tags) && (item.tags.length !== 0) ) || (item.links.length !== 0) ) ) &&
                <div className="tags">
                    { (item.links.length !== 0) &&
                        <IonChip data-color={"8"}>
                            <IonIcon style={{ margin: '-4px 6px -4px 0px', color: 'white' }} icon={linkOutline} />
                            <IonLabel>{item.links.length}</IonLabel> 
                        </IonChip>
                    }
                    { item.tags && item.tags.map(tagId => {
                        if (!this.props.tags) return null;
                        let tag = this.props.tags.filter(t => { return (t && t.id === tagId) })[0];
                        if (!tag) return null;
                        return ( <IonChip key={tagId} data-color={tag.color}> <IonLabel>{tag.name}</IonLabel> </IonChip> )
                    }) }
                </div>
            }
            { (this.props.view === "flashcard") &&
                <ImagePreviewModal
                    open={this.state.openImageI}
                    cardId={item.id}
                    url={item.image ? item.image[this.state.openImageI] : null}
                    onClose={() => {
                        this.setState({
                            openImageI: null
                        })
                    }}
                />
            }
        </React.Fragment>

        if (this.props.view === "flashcard") {
            return (
                <div
                    data-view={this.props.view} 
                    data-id={item.id} 
                    className="flashcard ioncard clearfix" 
                    style={{
                        overflow: 'hidden'
                    }}
                    onClick={() => {
                        this.props.onFlip(); 
                    }
                }>
                    {contentDOM}
                </div>
            );
        } else {
            return (
                <div 
                    data-view={this.props.view} 
                    data-id={item.id} 
                    className="flashcard ioncard clearfix"
                    data-selected={this.props.selected}
                    onClick={() => { 
                        Utilities.onDrawerShow();
                        this.props.onClick();
                    }}
                >
                    {contentDOM}
                </div>
            );
        }


    }

};


export default withIonLifeCycle(Flashcard);
